/**
 * OrderFormPreselect
 * ======================================
 * - preselect venue on orderform
 */

 const ELEMENTS = ".js-OrderFormPreselect";
 const FORM_SELECT = document.querySelector('#orderform select[name="venue"]')

 class OrderFormPreselect {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS);

     if (!this.elements) {
       return false;
     }

     this.elements.forEach((el) => {
       el.addEventListener("click", this.clickHandler);
     });
   }

   clickHandler = (e) => {
     const el = e.currentTarget;
     const parent = el.closest('.price-widget');
     const venue = parent.querySelector('select[name="venue"]')

     FORM_SELECT.value = venue.value
   };
 }

 new OrderFormPreselect();
